import { Helmet } from 'react-helmet';
import {
    Accordion, AccordionDetails, AccordionSummary,
    Avatar,
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, MenuItem, Paper, Select, Tab, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Tabs, TextField, Toolbar, Typography, IconButton, Alert, FormControl, InputLabel, OutlinedInput, InputAdornment, tableCellClasses
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import axios from "axios";
import CollapsibleTable from "../../components/planning/CollapsibleTable";
import DeleteIcon from '@mui/icons-material/Delete';
import PlanningChart from "../../components/planning/PlanningChart";
import DialogManageCarryScore from "../../components/planning/DialogManageCarryScore";
import PlanningSummary from "../../components/planning/PlanningSummary";
import DialogSendToApprove from "../../components/planning/DialogSendToApprove";
import DialogAddDetail from "../../components/planning/DialogAddDetail";
import { fetchPlanning, getCarryScore } from "../../actions/planning";
import PAPortion from "../../components/baseComponent/PAPortion";
import cssVariables from "../../theme/cssVariables";
import CollapsibleTable2 from "../../components/planning/CollapsibleTable_2";
import { fetchMasterUnit } from "../../actions/pickList";
import ListIcon from "../../assets/icons/List";
import DateIcon from "../../assets/icons/calendar-month.svg";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import DialogItemDetail from "../../components/planning/DialogItemDetail";
import DialogItemWorkDetail from "../../components/planning/DialogItemWorkDetail";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SettingsIcon from '@mui/icons-material/Settings';
import DoneIcon from '@mui/icons-material/Done';
import LaunchIcon from '@mui/icons-material/Launch';
import { ReactComponent as Launch } from "../../assets/images/launch.svg";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import CircleIcon from '@mui/icons-material/Circle';
import { makeStyles, styled } from "@mui/styles";
import TestTabNoBorder from "../../components/baseComponent/tab";
import Profile from "../../assets/images/profile/profile.jpg";
import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";
import { ReactComponent as SaveIcon } from "../../assets/images/save.svg";
import { ReactComponent as CancelIcon } from "../../assets/images/cancel.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar-month.svg";
import { ReactComponent as HourGlassIcon } from "../../assets/icons/hourglass.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/check-3.svg";
import { ReactComponent as CheckIcon2 } from "../../assets/icons/check-2.svg";
import { ReactComponent as MarkIcon } from "../../assets/icons/mark.svg";
import { ReactComponent as DraftIcon } from "../../assets/images/iconStatus/draft.svg";
import { ReactComponent as PendingIcon } from "../../assets/images/iconStatus/pending.svg";
import { ReactComponent as ApprovedIcon } from "../../assets/images/iconStatus/approved.svg";
import { ReactComponent as CancelIcon1 } from "../../assets/images/iconStatus/cancel.svg";
import { ReactComponent as RejectIcon } from "../../assets/images/iconStatus/reject.svg";
import { useParams } from "react-router-dom";
import planningService from "../../services/planning.service";
import SimpleDialog from "../../components/SimpleDialog";
import ConfirmDialog from "../../components/ConfirmDialog";
import MessageDialog from "../../components/inbox/MessageDialog";
import useUnsavedChangesWarning from "./useUnsavedChangesWarning";
import * as Util from "../../services/global.service";

const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    }
};

const Planing = () => {
    const _ = require('lodash');
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [Prompt, setDirty, setPristine] = useUnsavedChangesWarning();
    let { serial } = useParams();
    // local state
    const [value, setValue] = React.useState('all');
    const [isSuccessCancelDialogOpen, openSuccessCancelDialog] = React.useState(false);
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const [isConfirmCancelDialogOpen, openConfirmCancelDialog] = React.useState(false);
    const [dataPlanning, setDataPlanning] = React.useState([]);
    const [scoreTeaching, setScoreTeaching] = React.useState(0);
    const [scoreReserach, setscoreReserach] = React.useState(0);
    const [serialAccumulate, setSerialAccumulate] = React.useState(0);
    const [statusEdit, setSstatusEdit] = React.useState(false);
    const [statusSend, setSstatusSend] = React.useState(false);
    const [status, setStatus] = React.useState("");
    const [statusSave, setSstatusSave] = React.useState(false);
    const [closeMenu, setCloseMenu] = React.useState(false);
    const [openMenu, setOpenMenu] = React.useState(false);
    const [openAcc, setOpen] = React.useState("");
    const [openAdd, setOpenAdd] = React.useState("");
    const [statusValidate, setStatusValidate] = React.useState(false);
    const [AddData, setAdd] = React.useState({
        rb_category: {},
        evaluate_id: ""
    });
    const [checkAdd, setCheckAdd] = React.useState(true);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [datasError, setDatasError] = React.useState([]);
    const [scroll, setScroll] = React.useState(false);
    const [textWarning, settextWarning] = React.useState("");
    const [notFound, setNotFound] = React.useState(false);

    // redux state
    const planning = useSelector((state) => state.Planning);
    // group rubrics type
    const tabs = _.groupBy(planning.rubrics, function (loRow) {
        return loRow.rubricCat;
    })

    const sumData = () => {
        let sum = 0
        if (dataPlanning !== undefined && dataPlanning !== null && dataPlanning.length > 0) {
            dataPlanning.map((loRow) => { sum = sum + loRow?.count })
        }
        return sum
    }
    useEffect(() => {
        dispatch(fetchPlanning(serial)).then((rs) => {
            if (rs?.data === undefined || rs?.data === null) {
                setNotFound(true)
            }
        }).catch((rs) => {
            if (rs?.response?.data === undefined || rs?.response?.data === null) {
                setNotFound(true)
            }
        })
    }, []);

    useEffect(() => {
        AddData.evaluate_id = serial
    }, [serial]);

    useEffect(() => {
        setDataPlanning([])
    }, [notFound]);

    useEffect(() => {
        if (Object.keys(AddData.rb_category).length > 0) {
            setDirty();
        } else {
            setPristine();
        }
    }, [checkAdd]);

    useEffect(() => {
        getDataPlanning()
        setAdd({
            rb_category: {},
            evaluate_id: serial
        });
    }, [planning.planning]);

    useEffect(() => {
        if (dataPlanning !== undefined && dataPlanning !== null && dataPlanning !== "null" && dataPlanning.length > 0) {
            typeScore()
            checkError()
            checkSend()
        }
    }, [dataPlanning, checkAdd]);
    let getDataPlanning = () => {
        let oData = JSON.parse(JSON.stringify(planning))
        if (oData.planning !== undefined && oData.planning !== null && oData.planning.length > 0) {
            // oData.planning.sort(function (a, b) {
            //     return a.seq - b.seq;
            // });
            // for (let index = 0; index <= oData.planning.length - 1; index++) {
            //     oData.planning[index].rb_condition.sort(function (a, b) {
            //         return a.seq - b.seq;
            //     });
            // }
            setDataPlanning(oData.planning)
        }
        if (planning.rb_pa_data !== undefined && planning.rb_pa_data !== null && planning.rb_pa_data !== "null" && planning.rb_pa_data.length > 0) {
            seq()
        }
    }
    /** handle function*/
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // const [values, setValues] = React.useState(0);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const onEdit = () => {
        setSstatusEdit(true)
        setStatusValidate(false)
    }
    const onCancel = () => {
        handleConfirmCancelDialog(true)
    }
    const onSave = () => {
        if (Object.keys(AddData.rb_category).length > 0) {
            var data = {}
            for (let index = 0; index <= dataPlanning.length - 1; index++) {
                for (let indexs = 0; indexs <= dataPlanning.length - 1; indexs++) {
                    data[dataPlanning[index].serial] = { total_score: sumScore(dataPlanning[index]), accumulate_score: dataPlanning[index]?.accumulate_use }
                }
            }
            planningService.postAdd({ ...AddData, scores: data }).then(
                (response) => {
                    if (response?.data?.valid !== null && response?.data?.valid !== undefined && response?.data?.valid !== "" && response?.data?.valid === false) {
                        setOpen(response?.data?.serial)
                        setCheckAdd(!checkAdd)
                    } else {
                        dispatch(fetchPlanning(serial))
                        openSuccessSaveDialog(true)
                        setAdd({
                            rb_category: {},
                            evaluate_id: serial
                        });
                        setSstatusEdit(false)
                        setSstatusSave(true)
                        setStatusValidate(true)
                        setCheckAdd(!checkAdd)
                    }
                }).catch(() => {
                    seterrorText('กรุณาบันทึกการเปลี่ยนแปลง')
                    handleOpenFailedMessageDialog(true)
                    setCheckAdd(!checkAdd)
                })
        } else {
            setAdd({
                rb_category: {},
                evaluate_id: serial
            });
            setSstatusEdit(false)
            setSstatusSave(true)
            setStatusValidate(true)
            setCheckAdd(!checkAdd)
        }
    }
    const handleConfirmCancelDialog = (val) => {
        openConfirmCancelDialog(val)
    };
    const handleConfirmCancelList = () => {
        setAdd({
            rb_category: {},
            evaluate_id: serial
        });
        handleConfirmCancelDialog(false)
        openSuccessCancelDialog(true)
        getDataPlanning()
        setSstatusEdit(false)
        setCheckAdd(!checkAdd)
        if (statusSave) {
            setStatusValidate(true)
        }
    };
    // table customize
    const useStyles = makeStyles({
        root: {
            'border-width': 0,
            'padding-left': 0,
            [`&.${tableCellClasses.body}`]: {
                'border-width': 0,
                'padding-left': 0,
            }
        },
        tab: {
            fontSize: "16px !important",
            fontWeight: "300 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            }
        },
        profileContainer: {
            width: 70,
            height: 70,
            borderRadius: "50%",
            marginTop: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
    })

    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const openEditAcc = (data) => {
        setOpen(data);
    }
    const closeEditAcc = (data) => {
        setOpen("");
    }
    const openAddForm = (data) => {
        setOpenAdd(data);
    }
    const closeAddForm = (data) => {
        setOpenAdd("");
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const dateFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
            })
            return dateTH
        }
    }
    const dateDayFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
                day: 'numeric',
            })
            return dateTH
        }
    }
    const seq = () => {
        let seqs = 0
        let order = 0
        if (planning.rb_pa_data !== undefined && planning.rb_pa_data !== null && planning.rb_pa_data !== "null") {
            for (let index = 0; index <= planning.rb_pa_data.length - 1; index++) {
                if (seqs < planning.rb_pa_data[index].seq) {
                    seqs = planning.rb_pa_data[index].seq
                    order = index
                }
            }
            return planning.rb_pa_data[order]
        }
        // return {}
    }
    const typeScore = () => {
        if (dataPlanning !== undefined && dataPlanning !== null && dataPlanning !== "null") {
            var data = 0
            var accumulate = []
            for (let index = 0; index <= dataPlanning.length - 1; index++) {

                if (dataPlanning[index].accumulate !== null) {
                    accumulate = dataPlanning[index].accumulate.Accumulate.serial
                    setSerialAccumulate(accumulate);
                }
                if (dataPlanning[index].code === "T") {
                    data = sumScore(dataPlanning[index])
                    setScoreTeaching(data)
                }
                if (dataPlanning[index].code === "R") {
                    data = sumScore(dataPlanning[index])
                    setscoreReserach(data)
                }
            }
        }
    }
    const checkError = () => {
        let error = {}
        let type = []
        if (planning.criteria !== undefined && planning.criteria !== null && planning.criteria !== "") {
            for (let index = 0; index < planning.criteria.length; index++) {
                type = planning.criteria[index].description
                error = { ...error, [planning.criteria[index].serial]: planning.criteria[index].description }
            }
        }
        setDatasError(error);
    };

    const checkSend = () => {
        if (planning?.validate?.category !== undefined && planning?.validate?.category !== null && planning?.validate?.category !== "" && Object.keys(planning?.validate?.category).length > 0) {
            if (Object.keys(planning.validate.category).length > 0) {
                for (let index = 0; index <= Object.keys(planning.validate.category).length - 1; index++) {
                    for (let indexs = 0; indexs < planning.validate.category[Object.keys(planning.validate.category)[index]].length; indexs++) {
                        let check = planning.validate.category[Object.keys(planning.validate.category)[index]][indexs].status
                        if (check === "error") {
                            setSstatusSend(false)
                        } else {
                            setSstatusSend(true)
                        }
                    }
                }
            }
        } else if (planning?.validate === undefined || planning?.validate === null) {
            setSstatusSend(false)
        } else {
            setSstatusSend(true)
        }
    }
    // console.log(textWarning,7894);
    const displayError = (data) => {
        let colorError = { color: "#CC6058", background: "#CC60581A" }
        let colorWraning = { color: "#EFAD0A", background: "#EFAD0A1A" }
        let status = ""
        let texts = []
        let text = ""
        if (dataPlanning !== undefined && dataPlanning !== null && dataPlanning !== "") {
            if (planning?.validate?.category !== undefined && planning?.validate?.category !== null && planning?.validate?.category !== "" && Object.keys(planning.validate.category).length > 0) {
                let categoryData = planning?.validate.category[data]
                if (categoryData !== undefined && categoryData !== null && categoryData !== "") {
                    if (categoryData.length > 0) {
                        for (let index = 0; index <= categoryData.length - 1; index++) {
                            status = categoryData[index].status
                            if (status === "error") {
                                text = `• คะแนน${datasError[categoryData[index].key]}ไม่เป็นไปตามหลักเกณฑ์ที่กำหนด`
                            } else {
                                text = `• คะแนน${datasError[categoryData[index].key]}ไม่เป็นไปตามหลักเกณฑ์ที่กำหนด (สามารถส่งขออนุมัติได้)`
                            }
                            texts.push(text)
                        }
                    }
                }
            }
        }
        return (
            <>
                {texts.length > 0 ?
                    <Grid container xs={7} mb={2}>
                        <Grid item>
                            <Alert
                                icon={false}
                                sx={status === "error" ? colorError : colorWraning}
                            >
                                {texts.map((lv) => (
                                    <Typography>
                                        {lv}
                                    </Typography>
                                ))}
                            </Alert>
                        </Grid>
                    </Grid> : <Box></Box>}
            </>
        )
    }

    let calculateScore = (data) => {
        let sum = eval(data.calculate_score)
        let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
        return scores
    }

    let sumScore = (data) => {
        let totals = 0
        data.rb_condition.map((data) => { totals = totals + Number(calculateScore(data)) })
        return totals
    }

    let sumScoreAccumulateUse = (data) => {
        let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
        for (let index = 0; index <= data.rb_condition.length - 1; index++) {
            totals = totals + Number(calculateScore(data.rb_condition[index]))
        }
        return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    }

    const addData = async (value, type) => {
        let oData = dataPlanning
        let dataAdd = AddData
        let totals = 0
        let accumulate = {}
        let accumulate_use_data = {}
        let dataDel = {}
        let dataCon = {}
        let dataCate = {}
        if (type === "del") {
            for (let index = 0; index <= oData.length - 1; index++) {
                if (oData[index].serial === value.rubricCat) {
                    if (oData[index].rb_condition.map((data) => data.serial === value.serial).length > 0) {
                        for (let order = 0; order <= oData[index].rb_condition.length - 1; order++) {
                            if (oData[index].rb_condition[order].serial === value.serial) {
                                dataDel = oData[index].rb_condition[order]
                                oData[index].rb_condition = oData[index].rb_condition.filter((data) => data.serial !== value.serial)
                            }
                        }
                    }
                    // oData[index].rb_condition.map((data) => { totals = totals + calculateScore(data) })
                    totals = sumScoreAccumulateUse(oData[index])
                    oData[index].count = oData[index].rb_condition.length
                    dataCate = oData[index]
                    if (oData[index]?.accumulate_use_data) {
                        accumulate_use_data = oData[index]?.accumulate_use_data
                    }
                }
                if (oData[index]?.accumulate) {
                    accumulate = oData[index]?.accumulate
                }
            }
            if (dataAdd?.rb_category[value.rubricCat]?.rb_condition !== undefined && dataAdd?.rb_category[value.rubricCat]?.rb_condition[value?.serial] !== undefined) {
                let rb_pa_evaluate_condition_id = dataAdd?.rb_category[value.rubricCat]?.rb_condition[value?.serial]?.rb_pa_evaluate_condition_id
                if (rb_pa_evaluate_condition_id === undefined || rb_pa_evaluate_condition_id === null || rb_pa_evaluate_condition_id === "") {
                    delete dataAdd.rb_category[value.rubricCat].rb_condition[value.serial]
                } else {
                    dataAdd.rb_category[value.rubricCat].rb_condition[value.serial].method = "delete"
                    delete dataAdd.rb_category[value.rubricCat].rb_condition[value.serial].portfolio

                }
            } else {
                dataAdd.rb_category[value.rubricCat] = {
                    rb_category_id: value.rubricCat,
                    total_score: totals,
                    accumulate_use: dataAdd?.rb_category[value.rubricCat]?.accumulate_use !== undefined ? {
                        ...dataAdd?.rb_category[value.rubricCat]?.accumulate_use,
                        accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                        accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                    } : {
                        accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                        accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                        accumulate_data_use_id: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? accumulate_use_data?.serial : "",
                        score: dataCate?.accumulate_use !== undefined && dataCate?.accumulate_use !== null ? dataCate?.accumulate_use : 0,
                        status: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? "update" : "add",
                        is_accumulate: dataCate?.is_accumulate,
                    },
                    rb_condition: dataAdd?.rb_category[value.rubricCat]?.rb_condition !== undefined ? {
                        [value?.serial]: {
                            method: "delete",
                            rb_pa_evaluate_condition_id: value?.evaluate_condition?.serial !== undefined && value?.evaluate_condition?.serial !== null ? value?.evaluate_condition?.serial : "",
                            rubric_type: value?.rubricCat,
                            rb_condition_id: value?.serial,
                            quantity: Number(value?.quantity),
                            worth: value?.worth,
                            score: calculateScore(value),
                            remark: value?.remark,
                            academic_unit: value?.unit?.serial,
                        },
                        ...dataAdd.rb_category[value.rubricCat].rb_condition
                    }
                        : {
                            [value?.serial]: {
                                method: "delete",
                                rb_pa_evaluate_condition_id: value?.evaluate_condition?.serial !== undefined && value?.evaluate_condition?.serial !== null ? value?.evaluate_condition?.serial : "",
                                rubric_type: value?.rubricCat,
                                rb_condition_id: value?.serial,
                                quantity: Number(value?.quantity),
                                worth: value?.worth,
                                score: calculateScore(value),
                                remark: value?.remark,
                                academic_unit: value?.unit?.serial,
                            }
                        }
                }
            }
        } else {
            for (let index = 0; index <= oData.length - 1; index++) {
                if (oData[index].serial === value.serial) {
                    let newData = {
                        calculate_score: "data.quantity * data.worth",
                        code: value?.rubricCondition?.code,
                        description: value?.rubricCondition?.description,
                        evaluate_data: [],
                        quantity: value?.quantity,
                        remark: value?.remark,
                        seq: value?.rubricCondition?.seq,
                        rb_type_condition_serial: value?.rubricType?.rubric_type?.serial,
                        serial: value?.rubricCondition?.serial,
                        unit: value?.academic_unit,
                        worth: value?.worth,
                    }
                    if (oData[index].rb_condition.find((data) => data.serial === newData.serial) !== undefined) {
                        for (let order = 0; order <= oData[index].rb_condition.length - 1; order++) {
                            if (oData[index].rb_condition[order].serial === newData.serial) {
                                oData[index].rb_condition[order] = { ...oData[index].rb_condition[order], ...newData }
                                dataCon = oData[index].rb_condition[order]
                            }
                        }
                    } else {
                        oData[index].rb_condition = [...oData[index].rb_condition, { ...newData, portfolio: [] }]
                    }
                    // oData[index].rb_condition.map((data) => { totals = totals + calculateScore(data) })
                    totals = sumScoreAccumulateUse(oData[index])
                    oData[index].count = oData[index].rb_condition.length
                    dataCate = oData[index]
                    if (oData[index]?.accumulate_use_data) {
                        accumulate_use_data = oData[index]?.accumulate_use_data
                    }
                }
                if (oData[index]?.accumulate) {
                    accumulate = oData[index]?.accumulate
                }
            }
            let valueAdd = []
            if (dataCon?.portfolio !== undefined && dataCon?.portfolio !== null && dataCon?.portfolio.length > 0) {
                for (let index = 0; index <= dataCon.portfolio.length - 1; index++) {
                    valueAdd.push({
                        portfolio_id: dataCon.portfolio[index]?.serial,
                        score: calculateScore(dataCon.portfolio[index]),
                        quantity: Number(dataCon.portfolio[index]?.quantity),
                        worth: dataCon.portfolio[index]?.worth
                    })

                }
            }
            let beforeData = {}
            if (dataAdd?.rb_category[value.serial]?.rb_condition !== undefined && dataAdd?.rb_category[value.serial]?.rb_condition[value?.rubricCondition?.serial] !== undefined) {
                beforeData = dataAdd?.rb_category[value.serial]?.rb_condition[value?.rubricCondition?.serial]
                delete dataAdd?.rb_category[value.serial]?.rb_condition[value?.rubricCondition?.serial]
            }
            dataAdd.rb_category[value.serial] = {
                rb_category_id: value.serial,
                total_score: totals,
                accumulate_use: dataAdd?.rb_category[value.serial]?.accumulate_use !== undefined ? {
                    ...dataAdd?.rb_category[value.serial]?.accumulate_use,
                    accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                    accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                } : {
                    accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                    accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                    accumulate_data_use_id: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? accumulate_use_data?.serial : "",
                    score: dataCate?.accumulate_use !== undefined && dataCate?.accumulate_use !== null ? dataCate?.accumulate_use : 0,
                    status: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? "update" : "add",
                    is_accumulate: dataCate?.is_accumulate,
                },
                rb_condition: dataAdd?.rb_category[value.serial]?.rb_condition !== undefined ? {
                    [value?.rubricCondition?.serial]: {
                        method: value?.rb_pa_evaluate_condition_id !== undefined && value?.rb_pa_evaluate_condition_id !== null && value?.rb_pa_evaluate_condition_id !== "" ? "edit" : "add",
                        rb_pa_evaluate_condition_id: value?.rb_pa_evaluate_condition_id !== undefined && value?.rb_pa_evaluate_condition_id !== null ? value?.rb_pa_evaluate_condition_id : "",
                        rubric_type: value?.rubricType?.rubric_type?.serial,
                        rb_condition_id: value?.rubricCondition?.serial,
                        quantity: Number(value?.quantity),
                        worth: value?.worth,
                        score: value?.score,
                        remark: value?.remark,
                        academic_unit: value?.academic_unit?.serial,
                        portfolio: valueAdd
                    },
                    ...dataAdd.rb_category[value.serial].rb_condition
                }
                    : {
                        [value?.rubricCondition?.serial]: {
                            method: value?.rb_pa_evaluate_condition_id !== undefined && value?.rb_pa_evaluate_condition_id !== null && value?.rb_pa_evaluate_condition_id !== "" ? "edit" : "add",
                            rb_pa_evaluate_condition_id: value?.rb_pa_evaluate_condition_id !== undefined && value?.rb_pa_evaluate_condition_id !== null ? value?.rb_pa_evaluate_condition_id : "",
                            rubric_type: value?.rubricType?.rubric_type?.serial,
                            rb_condition_id: value?.rubricCondition?.serial,
                            quantity: Number(value?.quantity),
                            worth: value?.worth,
                            score: value?.score,
                            remark: value?.remark,
                            academic_unit: value?.academic_unit?.serial,
                            portfolio: valueAdd
                        }
                    }
            }

        }
        await setDataPlanning(oData)
        // await setAdd(dataAdd)
        await setCheckAdd(!checkAdd)
    }

    let selectWorkLoad = async (value, rubricCat, rubric_condition) => {
        let oData = dataPlanning
        let dataAdd = AddData
        let totals = 0
        let accumulate = {}
        let accumulate_use_data = {}
        let dataCondition = {}
        let dataCate = {}
        for (let index = 0; index <= oData.length - 1; index++) {
            if (oData[index].serial === rubricCat) {
                if (oData[index].rb_condition.filter((data) => data.serial === rubric_condition).length > 0) {
                    for (let order = 0; order <= oData[index].rb_condition.length - 1; order++) {
                        if (oData[index].rb_condition[order].serial === rubric_condition) {
                            oData[index].rb_condition[order].portfolio = value
                            dataCondition = oData[index].rb_condition[order]
                            totals = sumScoreAccumulateUse(oData[index])
                        }
                    }
                }
                dataCate = oData[index]
                if (oData[index]?.accumulate_use_data) {
                    accumulate_use_data = oData[index]?.accumulate_use_data
                }
            }
            if (oData[index]?.accumulate) {
                accumulate = oData[index]?.accumulate
            }
        }
        let valueAdd = []
        for (let index = 0; index <= value.length - 1; index++) {
            valueAdd.push({
                portfolio_id: value[index]?.serial,
                score: calculateScore(value[index]),
                quantity: Number(value[index]?.quantity),
                worth: value[index]?.worth
            })

        }
        let method = ""
        if (dataAdd?.rb_category[rubricCat]?.rb_condition !== undefined && dataAdd?.rb_category[rubricCat]?.rb_condition[rubric_condition] !== undefined) {
            method = dataAdd.rb_category[rubricCat].rb_condition[rubric_condition].method
            delete dataAdd.rb_category[rubricCat].rb_condition[rubric_condition]
        }
        dataAdd.rb_category[rubricCat] = {
            rb_category_id: rubricCat,
            total_score: totals,
            accumulate_use: dataAdd?.rb_category[rubricCat]?.accumulate_use !== undefined ? {
                ...dataAdd?.rb_category[rubricCat]?.accumulate_use,
                accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
            } : {
                accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                accumulate_data_use_id: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? accumulate_use_data?.serial : "",
                score: dataCate?.accumulate_use !== undefined && dataCate?.accumulate_use !== null ? dataCate?.accumulate_use : 0,
                status: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? "update" : "add",
                is_accumulate: dataCate?.is_accumulate,
            },
            rb_condition: dataAdd?.rb_category[rubricCat]?.rb_condition !== undefined ? {
                [rubric_condition]: {
                    method: method !== undefined && method !== null && method !== "" ? method : dataCondition?.evaluate_condition?.serial !== undefined && dataCondition?.evaluate_condition?.serial !== null && dataCondition?.evaluate_condition?.serial !== "" ? "edit" : "add",
                    rb_pa_evaluate_condition_id: dataCondition?.evaluate_condition?.serial !== undefined && dataCondition?.evaluate_condition?.serial !== null ? dataCondition?.evaluate_condition?.serial : "",
                    rubric_type: dataCondition?.rubric_category,
                    rb_condition_id: rubric_condition,
                    quantity: Number(dataCondition?.quantity),
                    worth: dataCondition?.worth,
                    score: calculateScore(dataCondition),
                    remark: dataCondition?.remark,
                    academic_unit: dataCondition?.unit?.serial,
                    portfolio: valueAdd
                },
                ...dataAdd.rb_category[rubricCat].rb_condition
            }
                : {
                    [rubric_condition]: {
                        method: method !== undefined && method !== null && method !== "" ? method : dataCondition?.evaluate_condition?.serial !== undefined && dataCondition?.evaluate_condition?.serial !== null && dataCondition?.evaluate_condition?.serial !== "" ? "edit" : "add",
                        rb_pa_evaluate_condition_id: dataCondition?.evaluate_condition?.serial !== undefined && dataCondition?.evaluate_condition?.serial !== null ? dataCondition?.evaluate_condition?.serial : "",
                        rubric_type: dataCondition?.rubric_category,
                        rb_condition_id: rubric_condition,
                        quantity: Number(dataCondition?.quantity),
                        worth: dataCondition?.worth,
                        score: calculateScore(dataCondition),
                        remark: dataCondition?.remark,
                        academic_unit: dataCondition?.unit?.serial,
                        portfolio: valueAdd
                    }
                }
        }

        await setDataPlanning(oData)

        await setCheckAdd(!checkAdd)

    }

    const onAddPress = async (value, rubricCat) => {
        setOpen("")
        let oData = dataPlanning
        let dataAdd = AddData
        let totals = 0
        let accumulate = {}
        let accumulate_use_data = {}
        let dataCondition = {}
        let dataCate = {}
        for (let index = 0; index <= oData.length - 1; index++) {
            if (oData[index].serial === rubricCat) {
                oData[index].accumulate_use_data = { ...oData[index].accumulate_use_data, score: value }
                oData[index].accumulate_use = value
                totals = sumScoreAccumulateUse(oData[index])
                dataCate = oData[index]
                if (oData[index]?.accumulate_use_data) {
                    accumulate_use_data = oData[index]?.accumulate_use_data
                }
            }
            if (oData[index]?.accumulate) {
                accumulate = oData[index]?.accumulate
            }
        }
        if (dataAdd.rb_category[rubricCat]?.rb_condition !== undefined) {
            dataAdd.rb_category[rubricCat] = {
                rb_category_id: rubricCat,
                total_score: totals,
                accumulate_use: {
                    accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                    accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                    accumulate_data_use_id: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? accumulate_use_data?.serial : "",
                    score: value,
                    status: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? "update" : "add",
                    is_accumulate: dataCate?.is_accumulate,
                },
                rb_condition: dataAdd.rb_category[rubricCat]?.rb_condition
            }
        } else {
            dataAdd.rb_category[rubricCat] = {
                rb_category_id: rubricCat,
                total_score: totals,
                accumulate_use: {
                    accumulate_id: accumulate?.Accumulate?.serial !== undefined && accumulate?.Accumulate?.serial !== null ? accumulate?.Accumulate?.serial : "",
                    accumulate_data_id: accumulate?.AccumulateData?.serial !== undefined && accumulate?.AccumulateData?.serial !== null ? accumulate?.AccumulateData?.serial : "",
                    accumulate_data_use_id: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? accumulate_use_data?.serial : "",
                    score: value,
                    status: accumulate_use_data?.serial !== undefined && accumulate_use_data?.serial !== null ? "update" : "add",
                    is_accumulate: dataCate?.is_accumulate,
                },
            }
        }
        await setDataPlanning(oData)

        await setCheckAdd(!checkAdd)
    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (openMenu) {
                setCloseMenu(!closeMenu)
                setScroll(true)
            }
        }
    }
    const statusOpen = (data) => {
        setOpenMenu(data)
    }
    return (
        <Box onScroll={onScroll} className="asd" style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                {Prompt}
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >จัดทำข้อตกลงภาระงาน</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Grid item md={12} xs={12}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Typography variant="h2" color="#404349" fontSize={30} lineHeight={1.495}>
                                        {planning?.rb_pa_data !== undefined && planning?.rb_pa_data !== null ?
                                            planning?.rb_pa_data[0]?.description : null}
                                    </Typography>
                                    <Box sx={{ flex: 2 }}></Box>
                                    {planning !== undefined && planning !== null ?
                                        planning?.is_owner === true && planning?.evaluate_status === "draft" ?
                                            !statusEdit ?
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Box sx={{ paddingRight: "30px" }}>
                                                        <Button onClick={onEdit} startIcon={<EditIcon />} sx={{ height: "45px" }} variant="outlined" >แก้ไข</Button>
                                                    </Box>
                                                    <DialogSendToApprove status={statusSend} dataSummary={planning.criteria} datasPlanning={dataPlanning} dataPA={planning} serial={serial} />
                                                </Box>
                                                :
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Box sx={{ paddingRight: "30px" }}>
                                                        <Button onClick={onCancel} startIcon={<CancelIcon />} sx={{ height: "45px" }} variant="contained" color="red" >ยกเลิก</Button>
                                                    </Box>
                                                    <Box>
                                                        <Button onClick={onSave} startIcon={<SaveIcon />} sx={{ height: "45px" }} variant="contained" >บันทึก</Button>
                                                    </Box>
                                                </Box>
                                            : null
                                        : null
                                    }
                                </Box>
                                <Grid container item pb={2} pt={2}>
                                    <Grid item xs sm md lg>
                                        <Card sx={{ height: 1 }}>
                                            <CardContent sx={{ px: 2 }}>
                                                <Grid container mb={2}>
                                                    <Grid item lg={6} xs={7} display="flex" alignItems="center">
                                                        <Typography variant="h3">ข้อตกลงภาระงาน</Typography>
                                                    </Grid>
                                                    <Grid item lg={6} xs={5} display="flex" justifyContent="flex-end">
                                                        <Box
                                                            sx={{
                                                                background: "#5DA19626",
                                                                borderRadius: "4px",
                                                                border: "1px solid #5DA196",
                                                                width: "fit-content",
                                                                padding: "3px 10px",
                                                            }}
                                                        >
                                                            <Typography
                                                                fontSize={18}
                                                                fontWeight={500}
                                                                color="primary"
                                                            >
                                                                คะแนนสะสม : {formatData(planning?.employee?.accumulate_score, "0")} {t('label.score')}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                <Grid container>
                                                    <Grid
                                                        item
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        mr={3}
                                                    >
                                                        {/* <img
                                                            className={`${classes.profileContainer}`}
                                                            src={planning?.employee?.photo}
                                                            alt=""
                                                        /> */}
                                                        <Avatar
                                                            src={planning?.employee?.photo}
                                                            sx={{
                                                                cursor: "pointer",
                                                                width: 80,
                                                                height: 80,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs sm md lg>
                                                        <Grid container>
                                                            <Grid item>
                                                                <Typography variant="h5" color="primary">
                                                                    {formatData(planning?.employee?.fullname, "-")}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            <Grid item xs sm md={6} >
                                                                <Typography variant="sub_label">{t('label.staffLevel')} <span style={styles.colorText}>{formatData(planning?.employee?.empsubgroup, "-")}</span></Typography>
                                                            </Grid>
                                                            <Grid item xs sm md={6} >
                                                                <Typography variant="sub_label">{t('label.position')} <span style={styles.colorText}>{formatData(planning?.employee?.position, "-")}</span></Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            <Grid item xs sm md={6} >
                                                                <Typography variant="sub_label">{t('label.lineOfWork')} <span style={styles.colorText}>{formatData(planning?.employee?.linegroup, "-")}</span></Typography>
                                                            </Grid>
                                                            <Grid item xs sm md={6} >
                                                                <Typography variant="sub_label">{t('label.bu')} <span style={styles.colorText}>{formatData(planning?.employee?.organization, "-")}</span></Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <Divider variant="middle" />
                                            <CardContent sx={{ px: 2 }}>
                                                <Grid container mt={0}>
                                                    <Grid
                                                        item
                                                        display="flex"
                                                        sx={{
                                                            flexFlow: "column",
                                                        }}
                                                    >
                                                        <Typography variant="h3">ภาพรวมข้อตกลงภาระงาน</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container mt={2} display="flex" alignItems="center">
                                                    <Grid item mr={1}>
                                                        <CalendarIcon></CalendarIcon>
                                                    </Grid>
                                                    <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                                                        <Box sx={{ width: "150px" }}>
                                                            <Typography variant="sub_label">
                                                                รอบข้อตกลงภาระงาน:
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs sm md>
                                                        <Typography>{dateFormat(seq()?.start)} - {dateFormat(seq()?.end)}</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container mt={1} display="flex" alignItems="center">
                                                    <Grid item mr={1}>
                                                        <CalendarIcon></CalendarIcon>
                                                    </Grid>
                                                    <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                                                        <Box sx={{ width: "150px" }}>
                                                            <Typography variant="sub_label">
                                                                ส่งภายในวันที่:
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs sm md>
                                                        <Typography>{dateDayFormat(seq()?.before)}</Typography>
                                                    </Grid>
                                                </Grid>
                                                {/* status box */}
                                                <Grid container mt={2} sx={{ maxWidth: "100%" }}>
                                                    <Grid item xs sm md lg>
                                                        {planning.rb_pa_data !== undefined && planning?.rb_pa_data !== null ?
                                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                <div
                                                                    style={{
                                                                        maxWidth: "380px",
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        background:
                                                                            planning?.rb_pa_data[0]?.status === "draft" ?
                                                                                "#F7B2541A"
                                                                                : planning?.rb_pa_data[0]?.status === "pending" ?
                                                                                    "#F280261A"
                                                                                    : planning?.rb_pa_data[0]?.status === "approved" ?
                                                                                        "#5DA1961A"
                                                                                        : planning?.rb_pa_data[0]?.status === "approved_cancel" ?
                                                                                            "#CC60581A"
                                                                                            : planning?.rb_pa_data[0]?.status === "rejected" ?
                                                                                                "#CC60581A"
                                                                                                : planning?.rb_pa_data[0]?.status === "pending_cancel" ?
                                                                                                    "#F280261A"
                                                                                                    : planning?.rb_pa_data[0]?.status === "cancel_cancel" || planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                                        "#8282821A" : "#FFFFFF",
                                                                        border:
                                                                            planning?.rb_pa_data[0]?.status === "draft" ?
                                                                                "1px solid #F9C47F"
                                                                                : planning?.rb_pa_data[0]?.status === "pending" ?
                                                                                    "1px solid #F28026"
                                                                                    : planning?.rb_pa_data[0]?.status === "approved" ?
                                                                                        "1px solid #5DA196"
                                                                                        : planning?.rb_pa_data[0]?.status === "approved_cancel" ?
                                                                                            "1px solid #CC6058"
                                                                                            : planning?.rb_pa_data[0]?.status === "rejected" ?
                                                                                                "1px solid #CC6058"
                                                                                                : planning?.rb_pa_data[0]?.status === "pending_cancel" ?
                                                                                                    "1px solid #F28026"
                                                                                                    : planning?.rb_pa_data[0]?.status === "cancel_cancel" || planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                                        "1px solid #828282" : "1px solid #DADADA",
                                                                        borderRadius: "5px",
                                                                        position: "relative",
                                                                        paddingBottom: "25px"

                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{ p: 1, display: "flex", alignItems: "center" }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                background:
                                                                                    planning?.rb_pa_data[0]?.status === "draft" ?
                                                                                        "#F9C47F"
                                                                                        : planning?.rb_pa_data[0]?.status === "pending" ?
                                                                                            "#F28026"
                                                                                            : planning?.rb_pa_data[0]?.status === "approved" ?
                                                                                                "#5DA196"
                                                                                                : planning?.rb_pa_data[0]?.status === "approved_cancel" ?
                                                                                                    "#CC6058"
                                                                                                    : planning?.rb_pa_data[0]?.status === "rejected" ?
                                                                                                        "#CC6058"
                                                                                                        : planning?.rb_pa_data[0]?.status === "pending_cancel" ?
                                                                                                            "#F28026"
                                                                                                            : planning?.rb_pa_data[0]?.status === "cancel_cancel" || planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                                                "#828282" : "#FAFAFA",
                                                                                border:
                                                                                    planning?.rb_pa_data[0]?.status === "draft" ||
                                                                                        planning?.rb_pa_data[0]?.status === "pending" ||
                                                                                        planning?.rb_pa_data[0]?.status === "approved" ||
                                                                                        planning?.rb_pa_data[0]?.status === "approved_cancel" ||
                                                                                        planning?.rb_pa_data[0]?.status === "rejected" ||
                                                                                        planning?.rb_pa_data[0]?.status === "pending_cancel" ||
                                                                                        planning?.rb_pa_data[0]?.status === "cancel_cancel" || planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                        "none" : "1px dashed #C4C4C4",
                                                                                borderRadius: "50%",
                                                                                width: "30px",
                                                                                height: "30px",
                                                                            }}
                                                                            sx={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            {/* <CheckIcon></CheckIcon> */}
                                                                            {
                                                                                planning?.rb_pa_data[0]?.status === "draft" ?
                                                                                    <DraftIcon></DraftIcon>
                                                                                    : planning?.rb_pa_data[0]?.status === "pending" ?
                                                                                        <PendingIcon></PendingIcon>
                                                                                        : planning?.rb_pa_data[0]?.status === "approved" ?
                                                                                            <ApprovedIcon></ApprovedIcon>
                                                                                            : planning?.rb_pa_data[0]?.status === "approved_cancel" ?
                                                                                                <CancelIcon1></CancelIcon1>
                                                                                                : planning?.rb_pa_data[0]?.status === "rejected" ?
                                                                                                    <RejectIcon></RejectIcon>
                                                                                                    : planning?.rb_pa_data[0]?.status === "pending_cancel" ?
                                                                                                        <PendingIcon></PendingIcon>
                                                                                                        : planning?.rb_pa_data[0]?.status === "cancel_cancel" || planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                                            <CancelIcon1></CancelIcon1>
                                                                                                            : null
                                                                            }
                                                                        </Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography fontSize="18" fontWeight="600"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[0]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[0]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[0]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[0]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[0]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}
                                                                            >
                                                                                จัดทำข้อตกลงภาระงาน
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                width: "30px",
                                                                            }}
                                                                        ></Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography variant="h6" fontWeight="400"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[0]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[0]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[0]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[0]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[0]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}>
                                                                                สถานะ : {formatData(planning?.rb_pa_data[0]?.status_description, "-")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            pb: 1,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                width: "30px",
                                                                            }}
                                                                        ></Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography variant="h6" fontWeight="400"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[0]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[0]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[0]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[0]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[0]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[0]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}>
                                                                                วันที่: {formatData(dateDayFormat(planning?.rb_pa_data[0]?.send_at), "-")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: 0,
                                                                            top: 0,
                                                                            margin: 6,
                                                                        }}
                                                                    >
                                                                        <InfoIcon></InfoIcon>
                                                                    </Box>
                                                                </div>
                                                                {/* connector */}
                                                                <div
                                                                    style={{
                                                                        borderTop: "3px dashed #E5E5E5",
                                                                        width: "100%",
                                                                        maxWidth: "10%"
                                                                    }}
                                                                ></div>
                                                                <div
                                                                    style={{
                                                                        maxWidth: "380px",
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        background:
                                                                            planning?.rb_pa_data[1]?.status === "draft" ?
                                                                                "#F7B2541A"
                                                                                : planning?.rb_pa_data[1]?.status === "pending" ?
                                                                                    "#F280261A"
                                                                                    : planning?.rb_pa_data[1]?.status === "approved" ?
                                                                                        "#5DA1961A"
                                                                                        : planning?.rb_pa_data[1]?.status === "approved_cancel" ?
                                                                                            "#CC60581A"
                                                                                            : planning?.rb_pa_data[1]?.status === "rejected" ?
                                                                                                "#CC60581A"
                                                                                                : planning?.rb_pa_data[1]?.status === "pending_cancel" ?
                                                                                                    "#F280261A"
                                                                                                    : planning?.rb_pa_data[1]?.status === "cancel_cancel" || planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                                        "#8282821A" : "#FFFFFF",
                                                                        border:
                                                                            planning?.rb_pa_data[1]?.status === "draft" ?
                                                                                "1px solid #F9C47F"
                                                                                : planning?.rb_pa_data[1]?.status === "pending" ?
                                                                                    "1px solid #F28026"
                                                                                    : planning?.rb_pa_data[1]?.status === "approved" ?
                                                                                        "1px solid #5DA196"
                                                                                        : planning?.rb_pa_data[1]?.status === "approved_cancel" ?
                                                                                            "1px solid #CC6058"
                                                                                            : planning?.rb_pa_data[1]?.status === "rejected" ?
                                                                                                "1px solid #CC6058"
                                                                                                : planning?.rb_pa_data[1]?.status === "pending_cancel" ?
                                                                                                    "1px solid #F28026"
                                                                                                    : planning?.rb_pa_data[1]?.status === "cancel_cancel" || planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                                        "1px solid #828282" : "1px solid #DADADA",
                                                                        borderRadius: "5px",
                                                                        position: "relative",
                                                                        paddingBottom: "25px"
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{ p: 1, display: "flex", alignItems: "center" }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                background:
                                                                                    planning?.rb_pa_data[1]?.status === "draft" ?
                                                                                        "#F9C47F"
                                                                                        : planning?.rb_pa_data[1]?.status === "pending" ?
                                                                                            "#F28026"
                                                                                            : planning?.rb_pa_data[1]?.status === "approved" ?
                                                                                                "#5DA196"
                                                                                                : planning?.rb_pa_data[1]?.status === "approved_cancel" ?
                                                                                                    "#CC6058"
                                                                                                    : planning?.rb_pa_data[1]?.status === "rejected" ?
                                                                                                        "#CC6058"
                                                                                                        : planning?.rb_pa_data[1]?.status === "pending_cancel" ?
                                                                                                            "#F28026"
                                                                                                            : planning?.rb_pa_data[1]?.status === "cancel_cancel" || planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                                                "#828282" : "#FAFAFA",
                                                                                border:
                                                                                    planning?.rb_pa_data[1]?.status === "draft" ||
                                                                                        planning?.rb_pa_data[1]?.status === "pending" ||
                                                                                        planning?.rb_pa_data[1]?.status === "approved" ||
                                                                                        planning?.rb_pa_data[1]?.status === "approved_cancel" ||
                                                                                        planning?.rb_pa_data[1]?.status === "rejected" ||
                                                                                        planning?.rb_pa_data[1]?.status === "pending_cancel" ||
                                                                                        planning?.rb_pa_data[1]?.status === "cancel_cancel" || planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                        "none" : "1px dashed #C4C4C4",
                                                                                borderRadius: "50%",
                                                                                width: "30px",
                                                                                height: "30px",
                                                                            }}
                                                                            sx={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            {
                                                                                planning?.rb_pa_data[1]?.status === "draft" ?
                                                                                    <DraftIcon></DraftIcon>
                                                                                    : planning?.rb_pa_data[1]?.status === "pending" ?
                                                                                        <PendingIcon></PendingIcon>
                                                                                        : planning?.rb_pa_data[1]?.status === "approved" ?
                                                                                            <ApprovedIcon></ApprovedIcon>
                                                                                            : planning?.rb_pa_data[1]?.status === "approved_cancel" ?
                                                                                                <CancelIcon1></CancelIcon1>
                                                                                                : planning?.rb_pa_data[1]?.status === "rejected" ?
                                                                                                    <RejectIcon></RejectIcon>
                                                                                                    : planning?.rb_pa_data[1]?.status === "pending_cancel" ?
                                                                                                        <PendingIcon></PendingIcon>
                                                                                                        : planning?.rb_pa_data[1]?.status === "cancel_cancel" || planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                                            <CancelIcon1></CancelIcon1>
                                                                                                            : null
                                                                            }
                                                                        </Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography fontSize="18" fontWeight="600"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[1]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[1]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[1]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[1]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[1]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}>
                                                                                บันทึกภาระงาน
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                width: "30px",
                                                                            }}
                                                                        ></Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography variant="h6" fontWeight="400"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[1]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[1]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[1]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[1]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[1]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}>
                                                                                สถานะ : {formatData(planning?.rb_pa_data[1]?.status_description, "ยังไม่ดำเนินการ")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            pb: 1,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                width: "30px",
                                                                            }}
                                                                        ></Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography variant="h6" fontWeight="400"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[1]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[1]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[1]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[1]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[1]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}>
                                                                                วันที่: {formatData(dateDayFormat(planning?.rb_pa_data[1]?.send_at), "-")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: 0,
                                                                            top: 0,
                                                                            margin: 6,
                                                                        }}
                                                                    >
                                                                        <InfoIcon></InfoIcon>
                                                                    </Box>
                                                                </div>
                                                                {/* connector */}
                                                                <div
                                                                    style={{
                                                                        borderTop: "3px dashed #E5E5E5",
                                                                        width: "100%",
                                                                        maxWidth: "10%"
                                                                    }}
                                                                ></div>
                                                                <div
                                                                    style={{
                                                                        maxWidth: "380px",
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        background:
                                                                            planning?.rb_pa_data[2]?.status === "draft" ?
                                                                                "#F7B2541A"
                                                                                : planning?.rb_pa_data[2]?.status === "pending" ?
                                                                                    "#F280261A"
                                                                                    : planning?.rb_pa_data[2]?.status === "approved" ?
                                                                                        "#5DA1961A"
                                                                                        : planning?.rb_pa_data[2]?.status === "approved_cancel" ?
                                                                                            "#CC60581A"
                                                                                            : planning?.rb_pa_data[2]?.status === "rejected" ?
                                                                                                "#CC60581A"
                                                                                                : planning?.rb_pa_data[2]?.status === "pending_cancel" ?
                                                                                                    "#F280261A"
                                                                                                    : planning?.rb_pa_data[2]?.status === "cancel_cancel" || planning?.rb_pa_data[2]?.status === "cancel" ?
                                                                                                        "#8282821A" : "#FFFFFF",
                                                                        border:
                                                                            planning?.rb_pa_data[2]?.status === "draft" ?
                                                                                "1px solid #F9C47F"
                                                                                : planning?.rb_pa_data[2]?.status === "pending" ?
                                                                                    "1px solid #F28026"
                                                                                    : planning?.rb_pa_data[2]?.status === "approved" ?
                                                                                        "1px solid #5DA196"
                                                                                        : planning?.rb_pa_data[2]?.status === "approved_cancel" ?
                                                                                            "1px solid #CC6058"
                                                                                            : planning?.rb_pa_data[2]?.status === "rejected" ?
                                                                                                "1px solid #CC6058"
                                                                                                : planning?.rb_pa_data[2]?.status === "pending_cancel" ?
                                                                                                    "1px solid #F28026"
                                                                                                    : planning?.rb_pa_data[2]?.status === "cancel_cancel" || planning?.rb_pa_data[2]?.status === "cancel" ?
                                                                                                        "1px solid #828282" : "1px solid #DADADA",
                                                                        borderRadius: "5px",
                                                                        position: "relative",
                                                                        paddingBottom: "25px"
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{ p: 1, display: "flex", alignItems: "center" }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                background:
                                                                                    planning?.rb_pa_data[1]?.status === "draft" ?
                                                                                        "#F9C47F"
                                                                                        : planning?.rb_pa_data[1]?.status === "pending" ?
                                                                                            "#F28026"
                                                                                            : planning?.rb_pa_data[1]?.status === "approved" ?
                                                                                                "#5DA196"
                                                                                                : planning?.rb_pa_data[1]?.status === "approved_cancel" ?
                                                                                                    "#CC6058"
                                                                                                    : planning?.rb_pa_data[1]?.status === "rejected" ?
                                                                                                        "#CC6058"
                                                                                                        : planning?.rb_pa_data[1]?.status === "pending_cancel" ?
                                                                                                            "#F28026"
                                                                                                            : planning?.rb_pa_data[1]?.status === "cancel_cancel" || planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                                                "#828282" : "#FAFAFA",
                                                                                border:
                                                                                    planning?.rb_pa_data[1]?.status === "draft" ||
                                                                                        planning?.rb_pa_data[1]?.status === "pending" ||
                                                                                        planning?.rb_pa_data[1]?.status === "approved" ||
                                                                                        planning?.rb_pa_data[1]?.status === "approved_cancel" ||
                                                                                        planning?.rb_pa_data[1]?.status === "rejected" ||
                                                                                        planning?.rb_pa_data[1]?.status === "pending_cancel" ||
                                                                                        planning?.rb_pa_data[1]?.status === "cancel_cancel" ||
                                                                                        planning?.rb_pa_data[1]?.status === "cancel" ?
                                                                                        "none" : "1px dashed #C4C4C4",
                                                                                borderRadius: "50%",
                                                                                width: "30px",
                                                                                height: "30px",
                                                                            }}
                                                                            sx={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            {
                                                                                planning?.rb_pa_data[2]?.status === "draft" ?
                                                                                    <DraftIcon></DraftIcon>
                                                                                    : planning?.rb_pa_data[2]?.status === "pending" ?
                                                                                        <PendingIcon></PendingIcon>
                                                                                        : planning?.rb_pa_data[2]?.status === "approved" ?
                                                                                            <ApprovedIcon></ApprovedIcon>
                                                                                            : planning?.rb_pa_data[2]?.status === "approved_cancel" ?
                                                                                                <CancelIcon1></CancelIcon1>
                                                                                                : planning?.rb_pa_data[2]?.status === "rejected" ?
                                                                                                    <RejectIcon></RejectIcon>
                                                                                                    : planning?.rb_pa_data[2]?.status === "pending_cancel" ?
                                                                                                        <PendingIcon></PendingIcon>
                                                                                                        : planning?.rb_pa_data[2]?.status === "cancel_cancel" || planning?.rb_pa_data[2]?.status === "cancel" ?
                                                                                                            <CancelIcon1></CancelIcon1>
                                                                                                            : null
                                                                            }
                                                                        </Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography
                                                                                fontSize="18"
                                                                                fontWeight="600"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[2]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[2]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[2]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[2]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[2]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}
                                                                            >
                                                                                รับทราบผลข้อตกลงภาระงาน
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                width: "30px",
                                                                            }}
                                                                        ></Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography
                                                                                variant="h6"
                                                                                fontWeight="400"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[2]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[2]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[2]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[2]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[2]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}
                                                                            >
                                                                                สถานะ : {formatData(planning?.rb_pa_data[2]?.status_description, "ยังไม่ดำเนินการ")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            pb: 1,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                width: "30px",
                                                                            }}
                                                                        ></Box>
                                                                        <Box sx={{ ml: 2 }}>
                                                                            <Typography
                                                                                variant="h6"
                                                                                fontWeight="400"
                                                                                sx={{
                                                                                    color:
                                                                                        planning?.rb_pa_data[2]?.status === "draft" ||
                                                                                            planning?.rb_pa_data[2]?.status === "pending" ||
                                                                                            planning?.rb_pa_data[2]?.status === "approved" ||
                                                                                            planning?.rb_pa_data[2]?.status === "approved_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "rejected" ||
                                                                                            planning?.rb_pa_data[2]?.status === "pending_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "cancel_cancel" ||
                                                                                            planning?.rb_pa_data[2]?.status === "cancel" ?
                                                                                            "#404349"
                                                                                            : "#C4C4C4"
                                                                                }}
                                                                            >
                                                                                วันที่: {formatData(dateDayFormat(planning?.rb_pa_data[2]?.send_at), "-")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Box
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: 0,
                                                                            top: 0,
                                                                            margin: 6,
                                                                        }}
                                                                    >
                                                                        <InfoIcon></InfoIcon>
                                                                    </Box>
                                                                </div>
                                                            </Box>
                                                            : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                {/* end status box */}

                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={4}>
                                <Grid item lg={6} xs={12}>
                                    <Card sx={{ height: 1 }}>
                                        <PAPortion datas={dataPlanning} dataPA={planning} checkAdd={checkAdd} />
                                    </Card>
                                </Grid>
                                <Grid item lg={6} xs={12}>
                                    <Card sx={{ height: 1 }}>
                                        <PlanningSummary dataSummary={planning.criteria} datasPlanning={dataPlanning} checkAdd={checkAdd} />
                                    </Card>
                                </Grid>
                                <Grid container item pb={2} pt={2} alignItems="center" sx={{ paddingTop: "30px", paddingBottom: "0px" }}>
                                    <Box sx={{ flex: 1 }} />
                                    <Launch style={styles.icon} />
                                    <Link
                                        component={RouterLink}
                                        to="/app/workload-and-performance"
                                    >
                                        <Typography fontSize="14px" lineHeight={1.1} fontWeight="300" variant="label">

                                            {t('label.goToplanning')}
                                        </Typography>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item lg={12} md={12}>
                            <Grid item md={12} pb={2} pt={2}>
                                <Divider />
                            </Grid>
                            <Box sx={{ display: 'flex', alignItems: "center" }}>
                                {/* <Grid container spacing={0} sx={{ display: 'flex' }}> */}
                                <Grid item>
                                    <div className={`${classes.iconContainer} ${classes.blueBg}`}>
                                        <ListIcon />
                                    </div>
                                </Grid>
                                <Grid container item>
                                    <Typography variant="h2" fontSize={30} lineHeight="33px" color="#404349" sx={{ paddingLeft: "20px" }}>
                                        {t('planning.label.workloadReport')}
                                    </Typography>
                                    <Box sx={{ flexGrow: 1 }} />
                                </Grid>
                                {/* </Grid> */}
                            </Box>

                            <Grid item md={12}>
                                <Grid container item pb={2} pt={2} alignItems="center">
                                    <Tabs
                                        value={value}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={handleChange}
                                    >
                                        <Tab label={t('label.all') + ` (${sumData()})`} value="all" classes={{ root: classes.tab }} />
                                        {dataPlanning !== undefined && dataPlanning !== null && dataPlanning.length > 0 ? dataPlanning.map((loRow) => (
                                            <Tab label={loRow.description + ` (` + loRow?.count + `)`} value={loRow} classes={{ root: classes.tab }} />
                                        ))
                                            : null}
                                    </Tabs>
                                </Grid>
                            </Grid>
                            {dataPlanning !== undefined && dataPlanning !== null && dataPlanning.length > 0 ? dataPlanning.map((loRow, index) => (
                                <>
                                    <Grid container spacing={5} sx={{ display: value === loRow || value === 'all' ? 'block' : 'none' }}>
                                        <Grid item lg={12}>
                                            <Toolbar color="primary" sx={loRow?.configuration !== undefined && loRow?.configuration !== null ? JSON.parse(loRow?.configuration) : {}}>
                                                <Box>
                                                    <Typography variant="h4_hilight" sx={loRow?.configuration !== undefined && loRow?.configuration !== null ? JSON.parse(loRow?.configuration) : {}}>
                                                        {loRow?.description}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ flexGrow: 1 }} />
                                                {statusEdit === true ? <>
                                                    <DialogManageCarryScore
                                                        isCarryScore={loRow.is_accumulate}
                                                        rubricCat={loRow}
                                                        id={serialAccumulate}
                                                        scoresTeaching={scoreTeaching}
                                                        scoresReserach={scoreReserach}
                                                        addAccumulate={onAddPress}
                                                        accumulateUse={loRow.accumulate_use}
                                                        p={4}
                                                        openAcc={openAcc}
                                                        onClose={closeEditAcc}
                                                    />
                                                    <DialogAddDetail rubricCat={loRow} id={loRow?.serial} add={addData} openAdd={openAdd} closeAddForm={closeAddForm} />
                                                </>
                                                    : null}
                                                {/*<Button color="primary" startIcon={<AddIcon/>}>{t('planning.label.' + loRow + 'Add')}</Button>*/}
                                            </Toolbar>
                                            {/*<CollapsibleTable data={tabs[loRow][0]['items']}/>*/}
                                            <CollapsibleTable2 closeMenu={closeMenu} status={statusOpen} delAccumulate={onAddPress} editAccumulate={openEditAcc} select={selectWorkLoad} edit={statusEdit} datas={loRow?.rb_condition} rubricCat={loRow} save={statusSave} editData={addData} id={loRow?.serial} allData={dataPlanning} openAdd={openAddForm} scroll={scroll} />
                                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                                {statusValidate ?
                                                    // planning?.validate.length > 0 ?
                                                    displayError(loRow.serial)
                                                    // : null
                                                    : <Box></Box>
                                                }
                                                <Toolbar sx={{ alignItems: "flex-start" }}>
                                                    <Box sx={{ flexGrow: 1 }} />
                                                    <Typography variant="h6" color={cssVariables.color.black} fontSize={18} lineHeight="27px">
                                                        {loRow?.total_description}:
                                                    </Typography>
                                                    <Typography variant="h6" color={cssVariables.color.black} pr={2} pl={2} fontSize={18} lineHeight="27px">
                                                        {sumScoreAccumulateUse(loRow)}
                                                    </Typography>
                                                    <Typography variant="h6" color={cssVariables.color.black} fontSize={18} lineHeight="27px">
                                                        {t('label.score')}
                                                    </Typography>
                                                </Toolbar>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </>
                            ))
                                : null}
                        </Grid>
                    </Grid>
                    <ConfirmDialog open={isConfirmCancelDialogOpen} warning={true} doConfirm={handleConfirmCancelList} setValue={handleConfirmCancelDialog} title="ยกเลิกการเปลี่ยนแปลง" text="ต้องการยกเลิกการเปลี่ยนแปลงทั้งหมดหรือไม่ ?" />
                    <SimpleDialog open={isSuccessSaveDialogOpen} setValue={openSuccessSaveDialog} save={true} text="บันทึกการเปลี่ยนแปลง" />
                    <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} />
                </Container>
            </Box>
        </Box>
    )
};
export default Planing;
